import { _ as _defineProperty, a as _objectWithoutProperties, c as classNames } from './_chunks/dep-96db17af.js';
import { createElement, forwardRef, useEffect } from 'react';
import useSizeProps from './util/use-size-props.js';
import { loadStylesheet } from './util/check-url-and-load.js';
import './util/use-common-classname.js';
import './util/use-config.js';
import './util/config-context.js';

var _excluded = ["icon", "id", "className", "size", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function render(node, id, rootProps) {
  return /*#__PURE__*/createElement(node.tag, _objectSpread(_objectSpread({
    key: id
  }, node.attrs), rootProps), (node.children || []).map(function (child, index) {
    return render(child, "".concat(id, "-").concat(node.tag, "-").concat(index));
  }));
}
var IconBase = /*#__PURE__*/forwardRef(function (props, ref) {
  var icon = props.icon,
    id = props.id,
    className = props.className,
    size = props.size,
    style = props.style,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useSizeProps = useSizeProps(size),
    sizeClassName = _useSizeProps.className,
    sizeStyle = _useSizeProps.style;
  var cls = classNames("t-icon", "t-icon-".concat(id), className, sizeClassName);
  useEffect(function () {
    loadStylesheet();
  }, []);
  return render(icon, "".concat(id), _objectSpread({
    ref: ref,
    className: cls,
    style: _objectSpread(_objectSpread({}, style), sizeStyle)
  }, restProps));
});

export { IconBase };
//# sourceMappingURL=icon.js.map
